module.exports = __webpack_public_path__ + "img/logo-lpn.0e48421a.jpg";